import { ERROR, PENDING, SUCCESS } from '../../design-system/constants';
import { AllActions } from '../../shared/redux/types';

import * as actions from './actions';
import { DiscussionStatusState } from './types';

export const discussionStatusReducer = (
    state: DiscussionStatusState = {},
    action: AllActions,
): DiscussionStatusState => {
    switch (action.type) {
        case actions.sendMessageRequestAction: {
            const { dossierId, sendingMessageId } = action;
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...state[dossierId].sendingMessage,
                        [sendingMessageId]: {
                            postContent: PENDING,
                        },
                    },
                    saveDraftMessage: undefined,
                },
            };
        }
        case actions.sendMessageFailureAction: {
            const { dossierId, sendingMessageId } = action;
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...state[dossierId].sendingMessage,
                        [sendingMessageId]: {
                            postContent: ERROR,
                        },
                    },
                },
            };
        }
        case actions.updateMessageRequestAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    updateMessage: PENDING,
                },
            };
        case actions.updateMessageFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    updateMessage: ERROR,
                },
            };
        case actions.getMessageSuccessAction:
            if (!action.sendingMessageId) {
                return {
                    ...state,
                    [action.dossierId]: {
                        ...state[action.dossierId],
                        updateMessage: SUCCESS,
                    },
                };
            }
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    sendingMessage: {
                        ...state[action.dossierId].sendingMessage,
                        [action.sendingMessageId]: undefined,
                    },
                },
            };
        case actions.fetchScheduledMessagesSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    updateMessage: SUCCESS,
                },
            };
        case actions.getDraftMessageRequestAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDraftMessage: PENDING,
                },
            };
        case actions.getDraftMessageSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDraftMessage: SUCCESS,
                },
            };
        case actions.getDraftMessageFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDraftMessage: ERROR,
                },
            };
        case actions.saveDraftMessageAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    saveDraftMessage: PENDING,
                },
            };
        case actions.saveDraftMessageSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    saveDraftMessage: SUCCESS,
                },
            };
        case actions.saveDraftMessageFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    saveDraftMessage: ERROR,
                },
            };
        default:
            return state;
    }
};
